// © Microsoft Corporation. All rights reserved.
/**
 * This will decide whether to create Alert for this app error or no alert. This can generate IcM ticket.
 * Alerts ones are tracked at http://aka.ms/AppErrors
 * NoAlerts will have separate tab just next to Errors aka Warnings. IcM ticket won't be generated when NoAlert is set.
 */
export var Severity;
(function (Severity) {
    /**
     * This is app error with default severity
     */
    Severity[Severity["Alert"] = 0] = "Alert";
    /**
     * This is app warning
     */
    Severity[Severity["NoAlert"] = 1] = "NoAlert";
    /**
     * This app error has high user impact
     */
    Severity[Severity["HighImpact"] = 2] = "HighImpact";
    /**
     * This is fatal app error
     */
    Severity[Severity["Critical"] = 3] = "Critical";
})(Severity || (Severity = {}));
//# sourceMappingURL=wwAppErrorTracker.js.map